var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScience = function SvgScience(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89334 7.26688L13.6667 4.74021C14.0467 4.48688 14.1467 3.9669 13.8933 3.59357L12.68 1.78688C12.4267 1.40688 11.9067 1.30689 11.5333 1.56022L7.76001 4.08689L9.89334 7.26688Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67995 6.94706L8.50662 7.73372L6.72662 8.92706L6.49329 9.08038L6.38662 8.92039L4.89329 6.69373L4.78662 6.53371L7.97329 4.40039L9.67995 6.94706Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75998 10.68L6.39332 8.92002L4.89998 6.69336L2.26665 8.45335C1.95999 8.66002 1.87998 9.07336 2.08665 9.38003L2.83999 10.5C3.03999 10.8067 3.45332 10.8867 3.75998 10.68Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.0399 14.5401C10.9733 14.5667 10.8999 14.5867 10.8333 14.5867C10.6399 14.5867 10.4599 14.4734 10.3733 14.2867L7.8866 8.7934L5.3666 14.2934C5.27993 14.4734 5.09993 14.5867 4.9066 14.5867C4.83993 14.5867 4.7666 14.5667 4.69993 14.5401C4.45327 14.4201 4.33993 14.1267 4.45326 13.8734L6.72659 8.92674L8.5066 7.7334L11.2866 13.8801C11.3999 14.1267 11.2866 14.4267 11.0399 14.5401Z",
    fill: "currentColor"
  })));
};
export default SvgScience;